import { defineMessages } from 'react-intl';
import {
    Clock,
    Close,
    MedicalTeam,
    Settings,
    WellGuide,
    Insurance,
} from '../../icons';

export const LOCALIZED_STRINGS = defineMessages({
    AppointmentHistory: {
        id: 'Components.UsernameDropdown.AppointmentHistory',
        defaultMessage: 'Appointment history',
    },
    Calendar: {
        id: 'Components.UsernameDropdown.Calendar',
        defaultMessage: 'Calendar',
    },
    Help: {
        id: 'Components.UsernameDropdown.Help',
        defaultMessage: 'Help',
    },
    Insurance: {
        id: 'Components.UsernameDropdown.Insurance',
        defaultMessage: 'Insurance',
    },
    MedicalTeam: {
        id: 'Components.UsernameDropdown.MedicalTeam',
        defaultMessage: 'My medical team',
    },
    Pulse: {
        id: 'Components.UsernameDropdown.Pulse',
        defaultMessage: 'Zocdoc Pulse',
    },
    Settings: {
        id: 'Components.UsernameDropdown.Settings',
        defaultMessage: 'Settings',
    },
    SignOut: {
        id: 'Components.UsernameDropdown.SignOut',
        defaultMessage: 'Sign out',
    },
    WellGuide: {
        id: 'Components.UsernameDropdown.WellGuide',
        defaultMessage: 'Well guide',
    },
    Patients: {
        id: 'Components.SignInDropdown.Patients',
        defaultMessage: 'Patients',
    },
    Doctors: {
        id: 'Components.SignInDropdown.Doctors',
        defaultMessage: 'Doctors',
    },
    LoginSignup: {
        id: 'Components.SignInDropdown.LoginSignup',
        defaultMessage: 'Log in / Sign up',
    },
    Login: {
        id: 'Components.SignInDropdown.Login',
        defaultMessage: 'Log in',
    },
    SoftLoginMessage: {
        id: 'Components.SoftLoggedIn.LoginLink',
        defaultMessage: 'Log in to view your notifications',
    },
    MyZodoc: {
        id: 'Components.NavigationLinks.MyZocdoc',
        defaultMessage: 'My Zocdoc',
    },
    MyWellGuide: {
        id: 'Components.NavigationLinks.MyWellGuide',
        defaultMessage: 'Well Guide',
    },
    PastAppointments: {
        id: 'Components.NavigationLinks.PastAppointments',
        defaultMessage: 'Past appointments',
    },
    Account: {
        id: 'Components.NavigationLinks.Account',
        defaultMessage: 'Account',
    },
    Notifications: {
        id: 'Layout.Header.Notifications',
        defaultMessage: 'Notifications',
    },
});

export const DropdownLinks = {
    appointmentHistory: '/patient/pastappointments',
    insurance: '/patient/insurancecardmanagement',
    medicalTeam: '/patient/medicalteam',
    providerCalendar: '/provider',
    providerAccount: '/provider/settings',
    providerHelp: '/provider/help',
    pulse: '/csr/default.aspx',
    settings: '/patient/editprofile',
    signout: '/signout',
    mobileWellnessTracker: '/patient/wellness',
    myWellGuide: name => `/mywellguide?name=${name}`,
    patientSignin: '/signin',
    providerSignin: '/signin?provider=1',
};
export const DesktopMyAccountLinks = [
    {
        key: LOCALIZED_STRINGS.Patients,
        url: DropdownLinks.patientSignin,
        message: LOCALIZED_STRINGS.LoginSignup,
        dataTest: 'patient-login',
    },
    {
        key: LOCALIZED_STRINGS.Doctors,
        url: DropdownLinks.providerSignin,
        message: LOCALIZED_STRINGS.Login,
        dataTest: 'doctor-login',
    },
];

export const MyAccountLinksConversionIds = {
    patient: 'HeaderLoginPatientClicked',
    provider: 'HeaderLoginProviderClicked',
};

const DesktopPatientLinks = [
    {
        message: LOCALIZED_STRINGS.MedicalTeam,
        url: DropdownLinks.medicalTeam,
        icon: MedicalTeam,
        dataTest: 'medical-team',
    },
    {
        message: LOCALIZED_STRINGS.AppointmentHistory,
        url: DropdownLinks.appointmentHistory,
        icon: Clock,
        dataTest: 'appointment-history',
    },
    {
        message: LOCALIZED_STRINGS.Settings,
        url: DropdownLinks.settings,
        icon: Settings,
        dataTest: 'settings',
    },
    {
        message: LOCALIZED_STRINGS.SignOut,
        url: DropdownLinks.signout,
        icon: Close,
        iconHeight: 14,
        dataTest: 'sign-out',
    },
];

export const DesktopPatientWithNavigationLinks = [
    {
        message: LOCALIZED_STRINGS.Settings,
        url: DropdownLinks.settings,
        icon: Settings,
        dataTest: 'settings',
    },
    {
        message: LOCALIZED_STRINGS.SignOut,
        url: DropdownLinks.signout,
        icon: Close,
        iconHeight: 14,
        dataTest: 'sign-out',
    },
];

const MobilePatientLinks = [
    {
        message: LOCALIZED_STRINGS.MedicalTeam,
        url: DropdownLinks.medicalTeam,
        icon: MedicalTeam,
        dataTest: 'medical-team',
    },
    {
        message: LOCALIZED_STRINGS.WellGuide,
        url: DropdownLinks.mobileWellnessTracker,
        icon: WellGuide,
        dataTest: 'well-guide',
    },
    {
        message: LOCALIZED_STRINGS.AppointmentHistory,
        url: DropdownLinks.appointmentHistory,
        icon: Clock,
        dataTest: 'appointment-history',
    },
    {
        message: LOCALIZED_STRINGS.Insurance,
        url: DropdownLinks.insurance,
        icon: Insurance,
        iconHeight: 19,
        dataTest: 'insurance',
    },
    {
        message: LOCALIZED_STRINGS.Settings,
        url: DropdownLinks.settings,
        icon: Settings,
        dataTest: 'settings',
    },
    {
        message: LOCALIZED_STRINGS.SignOut,
        url: DropdownLinks.signout,
        icon: Close,
        iconHeight: 18,
        dataTest: 'sign-out',
    },
];

const ProviderLinks = [
    {
        message: LOCALIZED_STRINGS.Calendar,
        url: DropdownLinks.providerCalendar,
        dataTest: 'provider-calendar',
    },
    {
        message: LOCALIZED_STRINGS.Help,
        url: DropdownLinks.providerHelp,
        dataTest: 'provider-help',
    },
    {
        message: LOCALIZED_STRINGS.SignOut,
        url: DropdownLinks.signout,
        dataTest: 'sign-out',
    },
];

const ZdEmployeeLinks = [
    {
        message: LOCALIZED_STRINGS.Pulse,
        url: DropdownLinks.pulse,
        dataTest: 'pulse',
    },
    {
        message: LOCALIZED_STRINGS.SignOut,
        url: DropdownLinks.signout,
        dataTest: 'sign-out',
    },
];

export const DesktopUserLinks = {
    Patient: DesktopPatientLinks,
    Provider: ProviderLinks,
    ZdEmployee: ZdEmployeeLinks,
};

export const MobileUserLinks = {
    Patient: MobilePatientLinks,
    Provider: ProviderLinks,
    ZdEmployee: ZdEmployeeLinks,
};

const desktopPatientNavLinks = patientFirstName => [
    {
        message: LOCALIZED_STRINGS.MyZodoc,
        url: DropdownLinks.medicalTeam,
        dataTest: 'my-zocdoc',
    },
    {
        message: LOCALIZED_STRINGS.MyWellGuide,
        url: DropdownLinks.myWellGuide(patientFirstName),
        dataTest: 'my-well-guide',
    },
    {
        message: LOCALIZED_STRINGS.PastAppointments,
        url: DropdownLinks.appointmentHistory,
        dataTest: 'past-appointments',
    },
];

const DesktopProviderNavLinks = [
    {
        message: LOCALIZED_STRINGS.Calendar,
        url: DropdownLinks.providerCalendar,
        dataTest: 'calendar',
    },
    {
        message: LOCALIZED_STRINGS.Account,
        url: DropdownLinks.providerAccount,
        dataTest: 'account',
    },
];

export const DesktopUserNavLinks = {
    patient: patientFirstName => desktopPatientNavLinks(patientFirstName),
    Provider: DesktopProviderNavLinks,
};
